import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../config.js";
import n from "./Error.js";
import e from "./Logger.js";
import { assumeNonNull as r, isSome as o, isNone as i } from "./maybe.js";
var s = e.getLogger("esri.core.urlUtils"),
    u = t.request,
    l = "esri/config: esriConfig.request.proxyUrl is not set.",
    c = /^\s*[a-z][a-z0-9-+.]*:(?![0-9])/i,
    f = /^\s*http:/i,
    a = /^\s*https:/i,
    h = /^\s*file:/i,
    p = /:\d+$/,
    d = /^https?:\/\/[^/]+\.arcgis.com\/sharing(\/|$)/i,
    g = new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?$"),
    m = new RegExp("^((([^\\[:]+):)?([^@]+)@)?(\\[([^\\]]+)\\]|([^\\[:]*))(:([0-9]+))?$");

var y = /*#__PURE__*/function () {
  function y() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    _classCallCheck(this, y);

    this.uri = t, this.scheme = null, this.authority = null, this.path = null, this.query = null, this.fragment = null, this.user = null, this.password = null, this.host = null, this.port = null;
    var n = r(this.uri.match(g));
    this.scheme = n[2] || (n[1] ? "" : null), this.authority = n[4] || (n[3] ? "" : null), this.path = n[5], this.query = n[7] || (n[6] ? "" : null), this.fragment = n[9] || (n[8] ? "" : null), null != this.authority && (n = r(this.authority.match(m)), this.user = n[3] || null, this.password = n[4] || null, this.host = n[6] || n[7], this.port = n[9] || null);
  }

  _createClass(y, [{
    key: "toString",
    value: function toString() {
      return this.uri;
    }
  }]);

  return y;
}();

var $ = new y(t.applicationUrl),
    x = {},
    w = function () {
  var t = r($.path),
      n = t.substring(0, t.lastIndexOf(t.split("/")[t.split("/").length - 1]));
  return "".concat("".concat($.scheme, "://").concat($.host).concat(null != $.port ? ":".concat($.port) : ""), n);
}();

function O(t) {
  var n = {
    path: null,
    query: null
  },
      e = new y(t),
      r = t.indexOf("?");
  return null === e.query ? n.path = t : (n.path = t.substring(0, r), n.query = b(e.query)), e.fragment && (n.hash = e.fragment, null === e.query && (n.path = n.path.substring(0, n.path.length - (e.fragment.length + 1)))), n;
}

function b(t) {
  var n = t.split("&"),
      e = {};

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;
      if (!_r) continue;

      var _t = _r.indexOf("=");

      var _n = void 0,
          _o = void 0;

      _t < 0 ? (_n = decodeURIComponent(_r), _o = "") : (_n = decodeURIComponent(_r.slice(0, _t)), _o = decodeURIComponent(_r.slice(_t + 1)));
      var _i = e[_n];
      "string" == typeof _i && (_i = e[_n] = [_i]), Array.isArray(_i) ? _i.push(_o) : e[_n] = _o;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return e;
}

function U(t) {
  return t && "object" == typeof t && "toJSON" in t && "function" == typeof t.toJSON;
}

function C(t, n) {
  return t ? n && "function" == typeof n ? Object.keys(t).map(function (e) {
    return encodeURIComponent(e) + "=" + encodeURIComponent(n(e, t[e]));
  }).join("&") : Object.keys(t).map(function (e) {
    var r = t[e];
    if (null == r) return "";
    var o = encodeURIComponent(e) + "=",
        i = n && n[e];
    return i ? o + encodeURIComponent(i(r)) : Array.isArray(r) ? r.map(function (t) {
      return U(t) ? o + encodeURIComponent(JSON.stringify(t)) : o + encodeURIComponent(t);
    }).join("&") : U(r) ? o + encodeURIComponent(JSON.stringify(r)) : o + encodeURIComponent(r);
  }).filter(function (t) {
    return t;
  }).join("&") : "";
}

function q() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  var e,
      r = u.proxyUrl;

  if ("string" == typeof t) {
    e = et(t);

    var _n2 = S(t);

    _n2 && (r = _n2.proxyUrl);
  } else e = !!t;

  if (!r) throw s.warn(l), new n("urlutils:proxy-not-set", l);
  e && lt() && (r = st(r));
  return O(r);
}

function R(t) {
  var n = S(t);
  var e, r;

  if (n) {
    var _t2 = v(n.proxyUrl);

    e = _t2.path, r = _t2.query ? b(_t2.query) : null;
  }

  if (e) {
    var _n3 = O(t);

    t = e + "?" + _n3.path;

    var _o2 = C(_objectSpread(_objectSpread({}, r), _n3.query));

    _o2 && (t = "".concat(t, "?").concat(_o2));
  }

  return t;
}

var j = {
  path: "",
  query: ""
};

function v(t) {
  var n = t.indexOf("?");
  return -1 !== n ? (j.path = t.slice(0, n), j.query = t.slice(n + 1)) : (j.path = t, j.query = null), j;
}

function L(t) {
  return t = (t = ct(t = pt(t = v(t).path), !0)).toLowerCase();
}

function I(t) {
  var n = {
    proxyUrl: t.proxyUrl,
    urlPrefix: L(t.urlPrefix)
  },
      e = u.proxyRules,
      r = n.urlPrefix;
  var o = e.length;

  for (var _i2 = 0; _i2 < e.length; _i2++) {
    var _t3 = e[_i2].urlPrefix;

    if (0 === r.indexOf(_t3)) {
      if (r.length === _t3.length) return -1;
      o = _i2;
      break;
    }

    0 === _t3.indexOf(r) && (o = _i2 + 1);
  }

  return e.splice(o, 0, n), o;
}

function S(t) {
  var n = u.proxyRules,
      e = L(t);

  for (var _r2 = 0; _r2 < n.length; _r2++) {
    if (0 === e.indexOf(n[_r2].urlPrefix)) return n[_r2];
  }
}

function A(t, n) {
  return t = P(t), n = P(n), ct(t) === ct(n);
}

function P(t) {
  var n = (t = W(t)).indexOf("/sharing");
  return n > 0 ? t.substring(0, n) : t.replace(/\/+$/, "");
}

function k(t) {
  var n = function n(_n4) {
    return null == _n4 || _n4 instanceof RegExp && _n4.test(t) || "string" == typeof _n4 && t.startsWith(_n4);
  },
      e = u.interceptors;

  if (e) {
    var _iterator2 = _createForOfIteratorHelper(e),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _r3 = _step2.value;

        if (Array.isArray(_r3.urls)) {
          if (_r3.urls.some(n)) return _r3;
        } else if (n(_r3.urls)) return _r3;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return null;
}

function B(t, n) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var r = xt(t),
      o = xt(n);
  return !(!e && r.scheme !== o.scheme) && null != r.host && null != o.host && r.host.toLowerCase() === o.host.toLowerCase() && r.port === o.port;
}

function E(t) {
  if ("string" == typeof t) {
    if (!M(t)) return !0;
    t = xt(t);
  }

  if (B(t, $)) return !0;
  var n = u.trustedServers || [];

  for (var _e = 0; _e < n.length; _e++) {
    var _r4 = J(n[_e]);

    for (var _n5 = 0; _n5 < _r4.length; _n5++) {
      if (B(t, _r4[_n5])) return !0;
    }
  }

  return !1;
}

function J(t) {
  return x[t] || (nt(t) || tt(t) ? x[t] = [new y(N(t))] : x[t] = [new y("http://".concat(t)), new y("https://".concat(t))]), x[t];
}

function N(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : w;
  var e = arguments.length > 2 ? arguments[2] : undefined;
  return tt(t) ? e && e.preserveProtocolRelative ? t : "http" === $.scheme && $.authority === D(t).slice(2) ? "http:".concat(t) : "https:".concat(t) : nt(t) ? t : r(z("/" === t[0] ? ft(n) : n, t));
}

function T(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : w;
  var e = arguments.length > 2 ? arguments[2] : undefined;
  if (!M(t)) return t;
  var r = W(t),
      o = r.toLowerCase(),
      i = W(n).toLowerCase().replace(/\/+$/, ""),
      s = e ? W(e).toLowerCase().replace(/\/+$/, "") : null;
  if (s && 0 !== i.indexOf(s)) return t;

  var u = function u(t, n, e) {
    return -1 === (e = t.indexOf(n, e)) ? t.length : e;
  };

  var l = u(o, "/", o.indexOf("//") + 2),
      c = -1;

  for (; o.slice(0, l + 1) === i.slice(0, l) + "/" && (c = l + 1, l !== o.length);) {
    l = u(o, "/", l + 1);
  }

  if (-1 === c) return t;
  if (s && c < s.length) return t;
  t = r.slice(c);
  var f = i.slice(c - 1).replace(/[^/]+/g, "").length;
  if (f > 0) for (var _a = 0; _a < f; _a++) {
    t = "../".concat(t);
  } else t = "./".concat(t);
  return t;
}

function W(t) {
  return t = yt(t = mt(t = gt(t = N(t = t.trim()))));
}

function z() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  var n = t.filter(o);
  if (!n || !n.length) return;
  var e = [];

  if (M(n[0])) {
    var _t4 = n[0],
        _r5 = _t4.indexOf("//");

    -1 !== _r5 && (e.push(_t4.slice(0, _r5 + 1)), ot(n[0]) && (e[0] += "/"), n[0] = _t4.slice(_r5 + 2));
  } else "/" === n[0][0] && e.push("");

  var r = n.reduce(function (t, n) {
    return n ? t.concat(n.split("/")) : t;
  }, []);

  for (var _o3 = 0; _o3 < r.length; _o3++) {
    var _t5 = r[_o3];
    ".." === _t5 && e.length > 0 && ".." !== e[e.length - 1] ? e.pop() : (!_t5 && _o3 === r.length - 1 || _t5 && ("." !== _t5 || 0 === e.length)) && e.push(_t5);
  }

  return e.join("/");
}

function D(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  if (Q(t) || F(t)) return null;
  var e = t.indexOf("://");
  if (-1 === e && tt(t)) e = 2;else {
    if (-1 === e) return null;
    e += 3;
  }
  var r = t.indexOf("/", e);
  return -1 !== r && (t = t.slice(0, r)), n && (t = ct(t, !0)), t;
}

function M(t) {
  return tt(t) || nt(t);
}

function Q(t) {
  return null != t && "blob:" === t.slice(0, 5);
}

function F(t) {
  return "data:" === t.slice(0, 5);
}

function G(t) {
  var n = K(t);
  if (!n || !n.isBase64) return null;
  var e = atob(n.data),
      r = new Uint8Array(e.length);

  for (var _o4 = 0; _o4 < e.length; _o4++) {
    r[_o4] = e.charCodeAt(_o4);
  }

  return r.buffer;
}

var H = /^data:(.*?)(;base64)?,(.*)$/;

function K(t) {
  var n = t.match(H);
  if (!n) return null;

  var _n6 = _slicedToArray(n, 4),
      e = _n6[1],
      r = _n6[2],
      o = _n6[3];

  return {
    mediaType: e,
    isBase64: !!r,
    data: o
  };
}

function V(t) {
  return t.isBase64 ? "data:".concat(t.mediaType, ";base64,").concat(t.data) : "data:".concat(t.mediaType, ",").concat(t.data);
}

function X(t) {
  var n = G(t);
  if (!n) return null;
  var e = K(t);
  return new Blob([n], {
    type: e.mediaType
  });
}

function Y(t, n) {
  Z(t, n) || _(t, n);
}

function Z(t, n) {
  var e = document.createElement("a");
  if (!("download" in e)) return !1;
  var r = null;
  var o = X(t);
  if (!o) return !1;
  r = URL.createObjectURL(o), e.download = n, e.href = r, e.style.display = "none", document.body.appendChild(e), e.click(), document.body.removeChild(e), URL.revokeObjectURL(r);
}

function _(t, n) {
  return !!window.navigator.msSaveOrOpenBlob && window.navigator.msSaveOrOpenBlob(X(t), n);
}

function tt(t) {
  return null != t && void 0 !== t && "/" === t[0] && "/" === t[1];
}

function nt(t) {
  return c.test(t);
}

function et(t) {
  return a.test(t) || "https" === $.scheme && tt(t);
}

function rt(t) {
  return f.test(t) || "http" === $.scheme && tt(t);
}

function ot(t) {
  return h.test(t);
}

function it(t) {
  return tt(t) ? "http:".concat(t) : t.replace(a, "http:");
}

function st(t) {
  return tt(t) ? "https:".concat(t) : t.replace(f, "https:");
}

function ut() {
  return "http" === $.scheme;
}

function lt() {
  return "https" === $.scheme;
}

function ct(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return tt(t) ? t.slice(2) : (t = t.replace(c, ""), n && t.length > 1 && "/" === t[0] && "/" === t[1] && (t = t.slice(2)), t);
}

function ft(t) {
  var n = t.indexOf("//"),
      e = t.indexOf("/", n + 2);
  return -1 === e ? t : t.slice(0, e);
}

function at(t) {
  var n = 0;

  if (M(t)) {
    var _e2 = t.indexOf("//");

    -1 !== _e2 && (n = _e2 + 2);
  }

  var e = t.lastIndexOf("/");
  return e < n ? t : t.slice(0, e + 1);
}

function ht(t, n) {
  if (!t) return "";
  var e = O(t).path.replace(/\/+$/, ""),
      r = e.substring(e.lastIndexOf("/") + 1);
  if (null == n || !n.length) return r;
  var o = new RegExp(".(".concat(n.join("|"), ")$"), "ig");
  return r.replace(o, "");
}

function pt(t) {
  return t && "/" === t[t.length - 1] ? t : "".concat(t, "/");
}

function dt(t) {
  return t.replace(/\/+$/, "");
}

function gt(t) {
  if (/^https?:\/\//i.test(t)) {
    var _n7 = v(t);

    t = (t = _n7.path.replace(/\/{2,}/g, "/")).replace("/", "//"), _n7.query && (t += "?".concat(_n7.query));
  }

  return t;
}

function mt(t) {
  return t.replace(/^(https?:\/\/)(arcgis\.com)/i, "$1www.$2");
}

function yt(t) {
  var n = u.httpsDomains;
  if (!rt(t)) return t;
  var e = t.indexOf("/", 7);
  var r;

  if (r = -1 === e ? t : t.slice(0, e), r = r.toLowerCase().slice(7), p.test(r)) {
    if (!r.endsWith(":80")) return t;
    r = r.slice(0, -3), t = t.replace(":80", "");
  }

  return ut() && r === $.authority && !d.test(t) || (lt() && r === $.authority || n && n.some(function (t) {
    return r === t || r.endsWith(".".concat(t));
  }) || lt() && !S(t)) && (t = st(t)), t;
}

function $t(t, n, e) {
  if (!(n && e && t && M(t))) return t;
  var r = t.indexOf("//"),
      o = t.indexOf("/", r + 2),
      i = t.indexOf(":", r + 2),
      s = Math.min(o < 0 ? t.length : o, i < 0 ? t.length : i);
  if (t.slice(r + 2, s).toLowerCase() !== n.toLowerCase()) return t;
  return "".concat(t.slice(0, r + 2)).concat(e).concat(t.slice(s));
}

function xt(t) {
  return "string" == typeof t ? new y(N(t)) : (t.scheme || (t.scheme = $.scheme), t);
}

function wt(t) {
  return jt.test(t);
}

function Ot(t, n) {
  var e = O(t),
      r = Object.keys(e.query || {});
  return r.length > 0 && n && n.warn("removeQueryParameters()", "Url query parameters are not supported, the following parameters have been removed: ".concat(r.join(", "), ".")), e.path;
}

function bt(t, n, e) {
  var r = O(t),
      o = r.query || {};
  return o[n] = String(e), "".concat(r.path, "?").concat(C(o));
}

function Ut(t, n) {
  var e = O(t),
      r = e.query || {};

  for (var _i3 in n) {
    r[_i3] = n[_i3];
  }

  var o = C(r);
  return o ? "".concat(e.path, "?").concat(o) : e.path;
}

function Ct(t, n) {
  var _O = O(t),
      e = _O.path,
      r = _O.query;

  if (!r) return t;
  delete r[n];
  var o = C(r);
  return o ? "".concat(e, "?").concat(o) : e;
}

function qt(t) {
  if (i(t)) return null;
  var n = t.match(Rt);
  return n ? n[1] : null;
}

var Rt = /.*?\.([^\/]*)$/,
    jt = /(^data:image\/svg|\.svg$)/i;
export { y as Url, R as addProxy, I as addProxyRule, bt as addQueryParameter, Ut as addQueryParameters, w as appBaseUrl, $ as appUrl, $t as changeDomain, K as dataComponents, G as dataToArrayBuffer, X as dataToBlob, Y as downloadDataAsFile, ht as getFilename, k as getInterceptor, D as getOrigin, qt as getPathExtension, S as getProxyRule, q as getProxyUrl, nt as hasProtocol, B as hasSameOrigin, A as hasSamePortal, M as isAbsolute, lt as isAppHTTPS, Q as isBlobProtocol, F as isDataProtocol, et as isHTTPSProtocol, tt as isProtocolRelative, wt as isSVG, E as isTrustedServer, z as join, N as makeAbsolute, V as makeData, T as makeRelative, W as normalize, C as objectToQuery, b as queryToObject, at as removeFile, Ct as removeQueryParameter, Ot as removeQueryParameters, dt as removeTrailingSlash, it as toHTTP, st as toHTTPS, x as trustedServersUrlCache, O as urlToObject };